<i18n>
{
    "cn": {
        "about_us": "关于我们",
        "talents": "人才",
        "shop": "商店",
        "gallery": "画廊",
        "study": "课程",
        "news": "新闻",
        "contact_us": "联系我们"
    },
    "en": {
        "about_us": "About",
        "talents": "Talent",
        "shop": "Shop",
        "gallery": "Gallery",
        "study": "Learn",
        "news": "News",
        "contact_us": "Contact"
    },
}
</i18n>
<script>
import { mapState } from 'vuex';
import messages from '../lang/messages';

export default {
    name: "Header",
    data() {
        return {
            messages,
            nav: [
                { name: this.$t('about_us'), link: '/about' },
                { name: this.$t('talents'), link: '/talents' },
                { name: this.$t('shop'), link: '/shop' },
                // { name: this.$t('gallery'), link: '/gallery' },
                // { name: this.$t('study'), link: '/study' },
                { name: this.$t('news'), link: '/news' },
                { name: this.$t('contact_us'), link: '/contactUs' },
            ],
            blackPath: ['/news', '/shop', '/gallery', '/login', '/register', '/shopping', '/vip'],
            notBlackPath: ['/news/detail'],
            // notBlackPath: [],
            isShowNav: true,
            showShoppingPath: ['/shop', '/gallery'],
        };
    },
    computed: {
        ...mapState(['userinfo']),
    },
    components: {
        
    },
    mounted() {

    },
    destroyed() {},
    watch: {
        '$route': {
            handler: function () { 
                this.isShowNav = false;
            }
        }
    },
    methods: {},
};
</script>

<template>
    <div class="header" ref="header" :class="{black: blackPath.some(v => $route.path.includes(v)) && !notBlackPath.some(v => $route.path.includes(v))}">
        <router-link class="logo" to="/"></router-link>
        <div class="mobile_btn_group flex only_mobile">
            <template v-if="showShoppingPath.some(v => $route.path.includes(v))">
                <router-link class="btn shopping layout_flex_center" to="/mine/userinfo">
                    <img v-if="userinfo.avatar" :src="userinfo.avatar" alt="" class="icon avatar"/>
                    <img v-else src="@/assets/images/icon_shop_user.png" alt="" class="icon"/>
                </router-link>
                <router-link class="btn shopping layout_flex_center" to="/shopping">
                    <img src="@/assets/images/icon_shop_bag.png" alt="" class="icon"/>
                </router-link>
            </template>
            <div class="btn nav_switch" :class="{active: isShowNav}" @click="isShowNav = !isShowNav">
                <span></span><span></span><span></span>
            </div>
        </div>
        <div class="nav_wrap" :class="{active: isShowNav}">
            <div class="nav">
                <div class="item" v-for="(item, index) in nav" :key="index">
                    <router-link :to="item.link">{{ item.name }}</router-link>
                </div>
            </div>
            <div class="lang">
                <a v-for="(item, index) in messages" :key="index" :class="{active: $i18n.locale == index}" :href="`${item.base ? '/' + item.base : ''}${$route.fullPath}`">{{ index }}</a>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.header{
    position: absolute;
    top: .7rem;
    width: 100%;
    padding: 0 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 100;
    @media only screen and (max-width: 750px) {
        height: 1.6rem;
        top: 0;
        background: #fff;
        border-bottom: 1px solid #666;
        padding: .7rem .3rem 0;
        position: sticky;
    }
    &.black{
        background: #000;
        position: relative;
        top: 0;
        // padding: .7rem 1rem;
        height: 1.9rem;
        @media only screen and (max-width: 750px) {
            height: 1.6rem;
            position: sticky;
            background: #fff;
            padding: .7rem .3rem 0;
        }
    }
    .logo{
        width: 2.39rem;
        height: .28rem;
        background: url('~@/assets/images/logo.png') no-repeat 0/100%;
        @media only screen and (max-width: 750px) {
            width: 3.06rem;
            height: .36rem;
            background-image: url('~@/assets/images/logo_black.png');
        }
    }
    .mobile_btn_group{
        gap: .2rem;
        .btn{
            width: .6rem;
            height: .6rem;
            border-radius: 50%;
            border: 1px solid #333;
            &.shopping{
                border: none;
                .icon{
                    width: 100%;
                    height: 100%;
                    &.avatar{
                        border-radius: 50%;
                    }
                }
            }
            &.nav_switch{
                position: relative;
                span{
                    width: 50%;
                    height: .04rem;
                    background: #333;
                    display: block;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    &:nth-of-type(1){
                        transform: translate(-50%, -250%);
                    }
                    &:nth-of-type(3){
                        transform: translate(-50%, 150%);
                    }
                    transition: all .3s;
                }
                &.active{
                    span{
                        &:nth-of-type(1){
                            transform: translate(-50%, -50%) rotate(45deg);
                        }
                        &:nth-of-type(3){
                            transform: translate(-50%, -50%) rotate(-45deg);
                        }
                        &:nth-of-type(2){
                            opacity: 0;
                        }
                    }
                }
            }
        }
    }
    .nav_wrap{
        display: flex;
        align-items: center;
        @media only screen and (max-width: 750px) {
            position: fixed;
            top: 1.6rem;
            left: 0;
            bottom: 0;
            width: 100%;
            background: #fff;
            flex-direction: column;
            justify-content: center;
            gap: .8rem;
            opacity: 0;
            visibility: hidden;
            transform: translate(100%, 0);
            transition: all .3s;
            &.active{
                opacity: 1;
                visibility: visible;
                transform: translate(0, 0);
            }
        }
    }
    .nav{
        background: #fff;
        border-radius: .1rem;
        display: flex;
        @media only screen and (max-width: 750px) {
            flex-direction: column;
            gap: .8rem;
        }
        .item{
            padding: 0 .3rem;
            line-height: .5rem;
            font-size: .18rem;
            position: relative;
            @media only screen and (max-width: 750px) {
                font-size: .32rem;
                text-align: center;
                line-height: 1;
            }
            a{
                min-width: .5rem;
                display: block;
                position: relative;
                overflow: hidden;
                text-align: justify;
                text-align-last: justify;
                @media only screen and (max-width: 750px) {
                    display: inline-block;
                    min-width: auto;
                }
                &::after{
                    content: "";
                    width: 100%;
                    height: 1px;
                    background: #000;
                    position: absolute;
                    left: 0;
                    top: .4rem;
                    transform: translate(-102%, 0);
                    transition: transform .3s;
                    @media only screen and (max-width: 750px) {
                        top: auto;
                        bottom: 0;
                        display: none;
                    }
                }
                &.active,
                &:hover{
                    &::after{
                        transform: translate(0, 0);
                    }
                    @media only screen and (max-width: 750px) {
                        font-weight: bold;
                        &::after{
                            display: block;
                        }
                    }
                }
            }
            &::after{
                content: "";
                width: 1px;
                height: .24rem;
                background: #000;
                position: absolute;
                right: 0;
                top: 50%;
                transform: translate(0, -50%);
                @media only screen and (max-width: 750px) {
                    display: none;
                }
            }
            &:last-child{
                &::after{
                    display: none;
                }
            }
        }
    }
    .lang{
        color: #666;
        margin-left: .35rem;
        font-size: .18rem;
        text-transform: uppercase;
        display: flex;
        gap: .15rem;
        line-height: .5rem;
        @media only screen and (max-width: 750px) {
            color: #999;
            font-size: .25rem;
            margin: 0;
            gap: .25rem;
        }
        a{
            display: block;
            cursor: pointer;
            &.active{
                color: #fff;
                @media only screen and (max-width: 750px) {
                    color: #333;
                }
            }
        }
    }
}
</style>